<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <div class="px-8 py-4 border-t border-gray-100 flex justify-end items-center space-x-2">
        <!-- Conditionally show buttons based on the current status -->

        <!-- Change Inden Part Button -->
        <button v-if="form.status !== 'inden_part'" class="btn-gray" @click="statusIndenPart(form.id)">Change Inden Part</button>

        <!-- Change Available Button -->
        <button v-if="form.status !== 'available'" class="btn-green" @click="statusAvailabel(form.id)">Change Available</button>

        <!-- Change Damaged Button -->
        <button v-if="form.status !== 'damaged'" class="btn-yellow" @click="statusDemage(form.id)">Change Damaged</button>
      </div>

      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <text-input v-model="form.code" :error="form.errors.code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Code Asset')" readonly />
        <text-input v-model="form.category" :error="form.errors.category" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Category')" readonly />
        <text-input v-model="form.type" :error="form.errors.type" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Type')" readonly />
        <text-input v-model="form.brand" :error="form.errors.brand" type="text" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Brand')" readonly />
        <text-input v-model="form.serial_number" :error="form.errors.serial_number" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Serial Number')" readonly />
        <text-input v-model="form.join_date" :error="form.errors.join_date" type="date" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Join Date')" readonly />

        <!-- Status Badge and dynamic text -->
        <div class="pr-6 pb-8 w-full lg:w-1/2">
          <label :for="__('Status Asset')" class="text-bold">{{ __('Status Asset') }}</label>
          <div class="mt-4">
            <span :class="statusClass" class="px-3 py-1 rounded-full">
              {{ statusText }}
              <!-- Dynamic status text -->
            </span>
          </div>
        </div>

        <textarea-input v-model="form.specification" :error="form.errors.specification" :rows="4" class="pb-6 w-full" placeholder="specification here.." :label="__('Specification')" readonly></textarea-input>

        <div class="flex flex-wrap w-full">
          <!-- Services Table -->
          <div class="w-full lg:w-1/2 pr-6 pb-8">
            <label class="form-label mb-6">{{ __('Service') }}:</label>
            <table class="w-full border-collapse border border-gray-200">
              <thead>
                <tr>
                  <th class="border border-gray-200 p-2 text-left">{{ __('Service Name') }}</th>
                  <th class="border border-gray-200 p-2 text-left">{{ __('Service Detail') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in form.services" :key="index">
                  <td class="border border-gray-200 p-2">{{ service.name }}</td>
                  <td class="border border-gray-200 p-2">{{ service.detail }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Change Parts Table -->
          <div class="w-full lg:w-1/2 pr-6 pb-8">
            <label class="form-label mb-6">{{ __('Change Part') }}:</label>
            <table class="w-full border-collapse border border-gray-200">
              <thead>
                <tr>
                  <th class="border border-gray-200 p-2 text-left">{{ __('Part Name') }}</th>
                  <th class="border border-gray-200 p-2 text-left">{{ __('Part Detail') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(change_part, index) in form.change_parts" :key="index">
                  <td class="border border-gray-200 p-2">{{ change_part.name }}</td>
                  <td class="border border-gray-200 p-2">{{ change_part.detail }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Head,
    TextInput,
    TextareaInput,
  },
  layout: Layout,
  props: {
    title: String,
    asset: Object,
    services: Array,
    change_parts: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        id: this.asset.id,
        code: this.asset.code,
        category: this.asset.category,
        type: this.asset.type,
        serial_number: this.asset.serial_number,
        brand: this.asset.brand,
        join_date: this.asset.join_date,
        specification: this.asset.specification,
        status: this.asset.status,
        services: this.services,
        change_parts: this.change_parts,
      }),
      user_access: this.$page.props.auth.user.access,
    }
  },
  computed: {
    statusClass() {
      switch (this.form.status) {
        case 'available':
          return 'bg-green-500 text-white font-bold'
        case 'outgoing':
          return 'bg-red-500 text-white font-bold'
        case 'inden_part':
          return 'bg-gray-500 text-white font-bold'
        case 'damaged':
          return 'bg-yellow-500 text-black font-bold'
        case 'sold':
          return 'bg-orange-500 text-white font-bold'
        default:
          return 'font-bold'
      }
    },
    // Computed property to return the status text dynamically
    statusText() {
      switch (this.form.status) {
        case 'available':
          return 'Available'
        case 'inden_part':
          return 'Inden Part'
        case 'damaged':
          return 'Damaged'
        case 'sold':
          return 'Sold'
        default:
          return 'Unknown Status'
      }
    },
  },
  methods: {
    statusAvailabel(id) {
      if (confirm('Are you sure you want to make this asset available?')) {
        this.$inertia.get(this.route('assets.available', id))
      }
    },
    statusIndenPart(id) {
      if (confirm('Are you sure you want to mark this asset as Inden Part?')) {
        this.$inertia.get(this.route('assets.inden_part', id))
      }
    },
    statusDemage(id) {
      if (confirm('Are you sure you want to mark this asset as damaged?')) {
        this.$inertia.get(this.route('assets.demaged', id))
      }
    },
  },
}
</script>

  <style scoped>
/* Define button styles */
.btn-gray {
  background-color: #6b7280;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  margin-right: 6px;
  font-weight: bold;
}

.btn-green {
  background-color: #10b981;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  margin-right: 6px;
  font-weight: bold;
}

.btn-yellow {
  background-color: #f59e0b;
  color: black;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  margin-right: 4px;
  font-weight: bold;
}

.btn:hover {
  opacity: 0.85;
}
</style>
